import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { IoMdNotifications } from "react-icons/io";
import ResetNotification from "./ResetNotification";
import ResetPassword from "./ResetPassword";
import { MdLock } from "react-icons/md";
import Select from "react-select";
import "./Setting.css";

export default function Setting() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeComp, setActiveComp] = useState({
    label: "Change Password",
    value: "#changePassword",
  });

  const menu = [
    { label: "Change Password", value: "#changePassword" },
    { label: "Notification", value: "#notification" },
  ];

  const handleRouteChange = (value) => {
    setActiveComp(value);
    navigate(`#${value}`);
  };

  const handlemenu = (e) => {
    setActiveComp(e);
    navigate(e.value);
  };

  useEffect(() => {
    navigate(`#changePassword`);
  }, []);

  return (
    <>
      <div className="w-100">
        <h1 className="setting_title">Setting</h1>
        <div className="setting_main d-flex flex-lg-row flex-column gap-md-4 gap-2 mt-2">
          <div className="sub_router_box d-sm-none d-block d-flex flex-lg-column flex-row gap-4 flex-wrap">
            <Select
              className="w-100 px-0"
              value={activeComp}
              onChange={handlemenu}
              options={menu}
            />
          </div>
          <div className="sub_router_box displaySmallNone d-flex flex-lg-column flex-row gap-4 flex-wrap">
            <div
              onClick={() => handleRouteChange("changePassword")}
              className={`${
                location?.hash?.includes("changePassword") && "active-subrouter"
              }`}
            >
              <MdLock />
              Change Password
            </div>
            <div
              onClick={() => handleRouteChange("notification")}
              className={`${
                location?.hash?.includes("notification") && "active-subrouter"
              }`}
            >
              <IoMdNotifications />
              Notification
            </div>
          </div>
          <div className="sub_router_comp">
            {location?.hash?.includes("notification") ? (
              <ResetNotification />
            ) : (
              <ResetPassword />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
